import Header from "../../components/header/index.js";
import LeftMenu from "../../components/left-menu/index.js";
import { Grid,Card, CardContent, FormControl, InputLabel } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import {  StaticDatePicker } from '@mui/x-date-pickers';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import Post from "../../pages/ListKontrak/Post.jsx";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem } from '@mui/material';
import { purple } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { Typography } from "@mui/material";
import { useSelector } from 'react-redux';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import InputAdornment from '@mui/material/InputAdornment';
export default function CreatePost(){
    const [address1,setAddress1] = useState("-")
    const nowstate = useSelector(state => state);
    const [sales,setSales]= useState(nowstate.user?.sales??"-")
    const [date,setDate]= useState(new Date())
    const [dateEnd,setDateEnd]= useState(new Date())
    const [posts, setPosts] = useState([])
    const [isEnd, setIsEnd] = useState(false);
    const [query,setQuery] = useState("")
    const [skip, setSkip] = useState(0)
    const [searchThis, setsearchThis]= useState("Phone");
    const [removedPost,setRemovedPost]=useState(0)
    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
    }
    const fetchPosts = async () => {
        if(query.trim()){
                try{
                    const { data, error } = await read(skip,query,searchThis,nowstate.user.sales);
                    if(error){
                        
                        console.log(error.message);
                        return;
                    }
                    console.log(data.data)

                    if(data.data?.length === 0){
                        setIsEnd(true);
                        return;
                    }


                    const yoyo = data.data

                    //success
                    setPosts([...posts, ...yoyo])
                }catch(error){
                    console.log(error);
                }
            
        }else{

        try{
            const { data, error } = await readEmpty(skip,nowstate.user.sales);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd(true);
                return;
            }

            
            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
        }
    }
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
    const previewInquiry = async (post) => {
        console.log("diatas")
        setCurrPreview(post)
        setPreviewVisibility(true)
        const currid = post._id
    }

    const [confirmDone,setConfirmDone] = useState(false)

    const confirmdonePost = async () => {
        console.log("diatas")
        setConfirmDone(true)
    }
    const handleCloseConfirmDone = (event) =>{
        setConfirmDone(false)
    }
   
    const getUniqueSales = () => {
        // Extract Sales data from both history and prevSales, defaulting to an empty array if they don't exist
    const historySales = (currPreview.history || []).map(item => item.Sales).filter(s => s !== 'OpenforFree');
    const prevSales = (currPreview.prevSales || []).map(item => item.Sales).filter(s => s !== 'OpenforFree');
    
    // Combine both arrays
    const combinedSales = [...historySales, ...prevSales];
    
    // Create a Set to remove duplicates and convert back to array
    const uniqueSales = Array.from(new Set(combinedSales));
    
    // Join the array into a string with commas
    return uniqueSales.join(', ');
      };

    useEffect(() => {
        if (posts.length === 0) {
            setIsEnd(true);
        } else {
            setIsEnd(false);
        }
    }, [posts]);

    useEffect(() => {
        // Fetch notifications initially
        fetchNotifications();
    
        // Set up polling interval
        const intervalId = setInterval(fetchNotifications, 300000); // 300000ms = 5 minutes
    
        // Clean up interval on component unmount
        return () => clearInterval(intervalId);
      }, []);

      const [notifications, setNotifications] = useState(0);


      const fetchNotifications = async () => {
            try {
              const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/inquiryNotification`);
              console.log(response.data)
              setNotifications(response.data.belumDiHandle);
            } catch (error) {
              console.error('Error fetching notifications:', error);
            }
      };
    

    const donePost = (postId) => {
        setRemovedPost(removedPost+1)
        setPosts(posts.filter(post => post._id !== postId));
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/updateInqContacted`,{
            id: currPreview._id, user: nowstate.user.sales, remindOption, textFieldValue, selectedCard, remindDate
        })
    };
    const takefreeforall = async() => {
        try {
            // Make sure the function is declared as async to use await
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/takefreeforallinq`, {
                user: nowstate.user.sales
            });
    
            console.log('Response:', response.data); // Log response data
    
            // This line will only execute after the axios.post resolves
            readEmpty(skip,nowstate.user.sales);
            await fetchNotifications();
            await fetchPosts();
        } catch (error) {
            console.error('Error making POST request:', error);
        }
    };

    const spamPost = (postId) => {
        setRemovedPost(removedPost+1)
        setPosts(posts.filter(post => post._id !== postId));
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/updatedInqSpam`,{
            id: currPreview._id, sales:nowstate.user.sales
        })
    };

    const invalidPost = (postId) => {
        setRemovedPost(removedPost+1)
        setPosts(posts.filter(post => post._id !== postId));
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/updatedInqNoneNumber`,{
            id: currPreview._id, sales:nowstate.user.sales
        })
    };

    useEffect(() => {
        fetchPosts();
        console.log(posts)
        
    }, [skip,query]);
    const commonStyles = {
        border: 1,
      };
      const formatDate = (dateString) => {
        if (!dateString) return '';
      
        const date = new Date(dateString);
      
        const optionsDate = {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        };
        
        const optionsTime = {
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23' // Use 24-hour format
        };
      
        const formattedDate = new Intl.DateTimeFormat('id-ID', optionsDate).format(date);
        const formattedTime = new Intl.DateTimeFormat('id-ID', optionsTime).format(date);
      
        return `${formattedDate} (${formattedTime})`;
      };
      const [remindOption, setRemindOption] = useState('Yes');
      const handleChange = (event) => {
        setRemindOption(event.target.value);
      };
      const [textFieldValue, setTextFieldValue] = useState('');
      const handletextFieldChange = (event) => {
        setTextFieldValue(event.target.value);
      };
      const handleSave = () => {
        if (!selectedCard) {
            alert('Mohon pencet Kulitas inquiry saat ini');
        } else if (remindOption === 'Drop' && textFieldValue.trim() === '') {
            alert('Mohon Beri alasan kenapa Inquiry mau di Drop');
        } else {
            donePost(currPreview._id);
            handleCloseConfirmDone();
            handleClosePreview();
            setSelectedCard(null)
            setRemindOption('Yes')
            setTextFieldValue('')
            setRemindDate(new Date(Date.now() + 3 * 24 * 60 * 60 * 1000))
        }
      };

      const CardContainer = styled(Card)(({ theme, selected }) => ({
        border: selected ? `2px solid ${theme.palette.primary.main}` : '2px solid transparent',
        cursor: 'pointer',
        textAlign: 'center',
        transition: 'border 0.3s ease',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }));
      const EmojiTypography = styled(Typography)({
        fontSize: '2rem', // Adjust this size as needed
      });
      const [selectedCard, setSelectedCard] = useState(null);

      const handleCardClick = (card) => {
        setSelectedCard(card);
      };


      const cards = [
        { id: 'card1', emoji: '🤔', text: 'Belum tau / Masih belum dibalas', score: 5 },
        { id: 'card2', emoji: '😊', text: 'Mungkin ada Potensi', score: 8 },
        { id: 'card3', emoji: '🤩', text: 'Sangat Bagus, Mau langsung Visit / Payment', score: 10 },
        { id: 'card4', emoji: '📵', text: 'Nomor Tidak Valid / Tidak Pernah Dibalas', score: 0 },
        { id: 'card5', emoji: '📍', text: 'Lokasi Tidak Sesuai', score: 3 },
        { id: 'card6', emoji: '📦', text: 'Produk Tidak Sesuai', score: 3 },
        { id: 'card7', emoji: '💸', text: 'Harga Tidak Sesuai', score: 7 },
        { id: 'card8', emoji: '🤬', text: 'Spam / Penipuan', score: -2 },
        { id: 'card9', emoji: '👻', text: 'Sudah 2-3X FU tidak pernah Respon Lagi', score: 1 },
      ];

      const [remindDate, setRemindDate] = useState(new Date(Date.now() + 3 * 24 * 60 * 60 * 1000));
      const handleDateChange = (event) => {
        setRemindDate(event);
      };
      const handleCloseConfirmDoneClear= () =>{
        setSelectedCard(null);
        setRemindOption('Yes');
        setTextFieldValue('');
        setRemindDate(new Date(Date.now() + 3 * 24 * 60 * 60 * 1000));
        handleCloseConfirmDone();
      }
return(
    <Grid container>
    <Dialog open={confirmDone}
                    onClose={handleCloseConfirmDone}> <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleCloseConfirmDone} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                        <Grid>
                            <Typography><b>
                             Sudah Follow Up ({currPreview.Nama ?? "Nama Tidak Tersedia"}) di ({currPreview.Phone?? "Nomor Telepon Tidak Tersedia"})?
                             </b></Typography>   
                        </Grid>
                        <Grid sx={{mt:2}}>
                            Bagaimana Kualitas Inquiry ini?
                            <Grid container spacing={2}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={2.4} key={card.id}>
          <CardContainer
            onClick={() => handleCardClick(card)}
            selected={selectedCard?.id === card.id}
          >
            <CardContent>
            <EmojiTypography variant="h1">{card.emoji}</EmojiTypography>
              <Typography variant="body1">{card.text}</Typography>
            </CardContent>
          </CardContainer>
        </Grid>
      ))}
    </Grid>
                        </Grid>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Grid sx={{ mt: 10 }}>
        Apakah mau di Remind lagi?
        <Grid container xs={11} sx={{ justifyContent: 'space-between',}}>
            <Grid xs={3}>
        <FormControl fullWidth>
          <Select
            labelId="remind-label"
            id="remind-select"
            value={remindOption}
            onChange={handleChange}
          >
            <MenuItem value="Yes">Yes</MenuItem>
            <MenuItem value="Drop">Drop</MenuItem>
          </Select>
        </FormControl>
        </Grid>
        <Grid xs={6}>
        {remindOption === 'Yes' && (
          <StaticDatePicker
            displayStaticWrapperAs="desktop"
            label="Choose Date"
            value={remindDate}
            onChange={handleDateChange}
            renderInput={(params) => <TextField {...params} />}
          />
        )}
        </Grid>
        </Grid>
      </Grid>
    </LocalizationProvider>
                        <Grid sx={{mt:5}}>
                            Catatan / Notes
                            <TextField
        multiline
        fullWidth
        rows={4}
        value={textFieldValue}
        onChange={handletextFieldChange}
        variant="outlined"
      />
                        </Grid>
                        <Grid sx={{ mt: 5, display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={handleCloseConfirmDoneClear} sx={{ mr: 2 }}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleSave}>
            Save
          </Button>
        </Grid>

                    </DialogContent>
                    </Dialog>
        <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth
                    maxWidth='lg'
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>

                    <Grid container>
                        <Grid item xs={9}>
                            <Grid container alignItems="center">
                                <Grid item xs={1}>
                                        <AccountCircleIcon style={{ fontSize: '5vw' }} />
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography fontSize="25px"><b>{currPreview.Nama ?? "Nama Tidak Tersedia"}</b></Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography fontSize="25px">{currPreview.Phone?? "Nomor Telepon Tidak Tersedia"}</Typography>
                                </Grid>
                                <Grid xs={2}>
                                    <Button 
                                            variant="contained" 
                                            color="success" 
                                            onClick={() => {
                                                const phoneNumber = currPreview.Phone; // Use the phone number from currPreview
                                                const message = ''; // Replace with your message or leave it empty
                                                const encodedMessage = encodeURIComponent(message);
                                                const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
                                                window.open(whatsappUrl, '_blank');
                                            }}
                                        >
                                        <WhatsAppIcon />
                                    </Button>
                                </Grid>
                            </Grid>
                            <Divider sx={{ borderBottomWidth: 2, borderColor:"black" }} />  {/* Adds a thicker divider line with top and bottom margins */}
                            <Grid container alignItems="center">
                                <Grid xs={6}>
                                    <Grid>
                                        <Typography>Status</Typography>
                                    </Grid>
                                    <Grid>
                                        <b>Inquiry {currPreview.newStat?? "n/a"}</b>
                                    </Grid>
                                </Grid>
                                <Grid xs={6}>
                                    <Grid>
                                        <Typography>Currently Assigned To</Typography>
                                    </Grid>
                                    <Grid>
                                        <b>{(!currPreview.Sales || currPreview.Sales === "OpenforAll") ? "Open" : currPreview.Sales}</b>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Divider sx={{ borderBottomWidth: 2, borderColor:"black" }} />  {/* Adds a thicker divider line with top and bottom margins */}
                            <Grid container>
                                <Typography fontSize="30px" sx={{mt:5, mb:1}}><b>Summary/Ringkasan</b></Typography>
                                <Grid xs={12} sx={{ml:2}}>
                                    <Typography fontSize="20px"><b>Apakah Pernah buat PI:</b> {currPreview.PIlink?? "tidak"}</Typography>
                                    <Typography fontSize="20px"><b>Produk:</b> {Array.isArray(currPreview.ProdukInterest) 
                                    ? currPreview.ProdukInterest.join(', ')
                                    : (currPreview.ProdukInterest ? String(currPreview.ProdukInterest) : 'N/A')} </Typography>
                                    <Typography fontSize="20px">Lokasi: {Array.isArray(currPreview.LokasiInterest) 
                                    ? currPreview.LokasiInterest.join(', ')
                                    : (currPreview.LokasiInterest ? String(currPreview.LokasiInterest) : 'N/A')}</Typography>
                                    {currPreview.chatLink ? (
                                        <Grid xs={12} sx={{ mb: 5, mt:5, display: 'flex',}}>
                                            <Button 
                                                variant="contained" 
                                                onClick={() => window.open(currPreview.chatLink, '_blank')}
                                                
                                            >
                                                Cek Chat Qontak/LC
                                            </Button>
                                        </Grid>
                                    ) : (
                                        <Grid xs={12} sx={{ mb: 5,mt:5, display: 'flex', }}>
                                            <Button 
                                                variant="contained" 
                                                disabled 
                                            >
                                                Cek Chat #1
                                            </Button>                                    
                                        </Grid>
                                    )}
                                </Grid>  
                            </Grid>
                            <Divider sx={{ borderBottomWidth: 2, borderColor:"black" }} />  {/* Adds a thicker divider line with top and bottom margins */}
                            <Grid item xs={12} sx={{ mb: 5, mt:5, display: 'flex', justifyContent: 'center' }}>
                                <Button 
                                    variant="contained" 
                                    color="success" 
                                    onClick={() => {
                                        confirmdonePost();
                                    }}
                                >
                                    Sudah Follow Up
                                </Button>
                            </Grid>
                            <Divider sx={{ borderBottomWidth: 2, borderColor:"black" }} />  {/* Adds a thicker divider line with top and bottom margins */}
                            
                        </Grid>
                        <Grid item xs={3}>
                            <Typography>Management notes</Typography>
                            
                        </Grid>
                        <Grid sx={{ display: 'flex',mt:3,  justifyContent: 'center' }}  container>
                            <Typography textAlign="center" fontSize="25px"><b>Lead History</b></Typography>
                            <TableContainer component={Paper} sx={{ mt: 3 }}>
                                <Table>
                                <TableHead>
                                    <TableRow>
                                    <TableCell><b>Date Modified</b></TableCell>
                                    <TableCell><b>Stat</b></TableCell>
                                    <TableCell><b>Sales</b></TableCell>
                                    <TableCell><b>Keterangan</b></TableCell>
                                    <TableCell><b>Action</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {currPreview.history && currPreview.history.length > 0 ? (
                                        currPreview.history.map((item, index) => (
                                        <TableRow key={index}>
                                        <TableCell>{formatDate(item.dateNotified) ?? ''}</TableCell>
                                        <TableCell>{item.Stat ?? ''}</TableCell>
                                        <TableCell>{item.Sales ?? ''}</TableCell>
                                        <TableCell>{item.Keterangan ?? ''}</TableCell>
                                        <TableCell>{item.Action ?? ''}</TableCell>
                                        </TableRow>
                                    ))
                                    ) : (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">No Data Available</TableCell>
                                    </TableRow>
                                    )}
                                </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                    </DialogActions>
        </Dialog>


    <Grid xs={12}>
    <Grid sx={{mb:2}}>
                            <Typography align="center" variant="h5"><b>FU Inquiry</b>

                            </Typography>
    </Grid>
    <Paper sx={{height: '100%', width:'100%'}}>
        <TableContainer sx={{ maxHeight: 300, minHeight: 300 }} className="min-h-screen h-screen overflow-scroll">
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                    <TableCell sx={{...commonStyles, borderColor: 'grey.100' }}>
                            Nama
                        </TableCell>
                        <TableCell sx={{...commonStyles, borderColor: 'grey.100' }}>
                            Nomor
                        </TableCell>
                        <TableCell sx={{...commonStyles, borderColor: 'grey.100' }}>
                            Produk
                        </TableCell>
                        <TableCell sx={{...commonStyles, borderColor: 'grey.100' }}>
                            Lokasi
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {posts && posts.length > 0 ? (
                        posts.map((post) => (
                            <TableRow hover key={post.id}> {/* Ensure to use a unique key for each row */}
                                <TableCell sx={{...commonStyles, borderColor: 'grey.100' }} onClick={()=> previewInquiry(post)}  style={{cursor:'pointer'}}>
                                {post.Nama 
                                    ? post.Nama.slice(0, 7)
                                    : 'N/A'}
                                </TableCell>
                                <TableCell sx={{...commonStyles, borderColor: 'grey.100' }} onClick={()=> previewInquiry(post)}  style={{cursor:'pointer'}}>
                                    {post.Phone}
                                </TableCell>
                                <TableCell sx={{...commonStyles, borderColor: 'grey.100' }} onClick={()=> previewInquiry(post)}  style={{cursor:'pointer'}}>
                                    {Array.isArray(post.ProdukInterest) 
                                    ? post.ProdukInterest.join(', ').slice(0, 7)
                                    : (post.ProdukInterest ? String(post.ProdukInterest).slice(0, 7) : 'N/A')}
                                </TableCell>
                                <TableCell sx={{...commonStyles, borderColor: 'grey.100' }} onClick={()=> previewInquiry(post)}  style={{cursor:'pointer'}}>
                                    {Array.isArray(post.LokasiInterest) 
                                    ? post.LokasiInterest.join(', ').slice(0, 7)
                                    : (post.LokasiInterest ? String(post.LokasiInterest).slice(0, 7) : 'N/A')}
                                </TableCell>
                                {/* Other TableCell components */}
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={5} style={{ textAlign: "center" }}>
                                Done
                            </TableCell>
                        </TableRow>
                    )}
                    {isEnd && (
                        <TableRow>
                            <TableCell colSpan={5} style={{ textAlign: "center" }}>
                                Tidak ada lagi yang bisa di FollowUp
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>

            </Table>
        </TableContainer>
        </Paper>
        </Grid>


    </Grid>
)
}